import { BASE_PLAN_SUB_TYPES, BillingCycleEnum, NEW_PRO_CATEGORY, planTypes, maxBizAndBizPlusLicenseCount, ZOOM_MEETING_PRO_MIN_LICENSE, ZOOM_MEETING_EDUCATION_MIN_LICENSE, ZOOM_MEETING_EDUCATION_MAX_LICENSE } from '@/common/constants';
import { defaultMapper } from "@/common/service/default-mapper";
import { ZOOM_MEETING_SUB_TYPES, isBizEditContext, isBizPlusContext, getMeetingPlanByCategory, ZOOM_METTING_EDU_I18N_TITLE_KEY } from './common/utils';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import { planUnitMap } from '@/common/product-unit';

// The zoomMeetingCategory field is required to classify biz plus and zoom united.
const MeetingExtralField = {
    [ZOOM_MEETING_SUB_TYPES.PRO]: { max: 99, min: 1, participants: 100, zoomMeetingCategory: ZOOM_MEETING_SUB_TYPES.PRO, planNameKey: 'billing.planform.title.zoom_one_pro', sub_type: BASE_PLAN_SUB_TYPES.PRO },
    [ZOOM_MEETING_SUB_TYPES.BIZ]: { max: maxBizAndBizPlusLicenseCount, min: isBizPlusContext ? 1 : ZOOM_MEETING_PRO_MIN_LICENSE, participants: 300, zoomMeetingCategory: ZOOM_MEETING_SUB_TYPES.BIZ, planNameKey: 'billing.planform.title.zoom_one_biz', sub_type: BASE_PLAN_SUB_TYPES.BIZ },
    [ZOOM_MEETING_SUB_TYPES.EDUCATION]: {
      max: ZOOM_MEETING_EDUCATION_MAX_LICENSE,
      min: ZOOM_MEETING_EDUCATION_MIN_LICENSE,
      participants: 300,
      zoomMeetingCategory: ZOOM_MEETING_SUB_TYPES.EDUCATION,
      planNameKey: ZOOM_METTING_EDU_I18N_TITLE_KEY,
      sub_type: BASE_PLAN_SUB_TYPES.EDUCATION
    },
    zo_edu_sch_cmp: {
        max: 250,
        min: 20,
        participants: 300,
        zoomMeetingCategory: ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP,
        planNameKey: 'billing.planform.title.zo_edu_sch_cmp',
        sub_type: BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP
    },
    [ZOOM_MEETING_SUB_TYPES.SINGLE_USE_PRO]: {
        planNameKey: 'billing.planform.title.zoom_one_pro'
    }
}

// pro price increase/down case, multiple rate plan shouldn't change rate plan type
function handleProMultipleRatePlan(subscriptions, item) {
  const proPlan = subscriptions.find((s) => [ZOOM_MEETING_SUB_TYPES.PRO, NEW_PRO_CATEGORY].includes(s.category) && s.ratePlans?.length > 1 && s.billingCycle === BillingCycleEnum[item.billing_cycle]);
  if (proPlan) {
    item.plan_code = proPlan.plan_code;
  }
}

export default (planMapJSON, that, subscriptions) => {
    const meetingPlans = Object.keys(MeetingExtralField).reduce((pre, key) => {
        return [
            ...pre,
            ...defaultMapper(planMapJSON[key], planTypes.ZOOM_MEETING).map(item => {
                const extraFields = MeetingExtralField[key];

                if (pageConfig.type === flowTypes.edit && key === BASE_PLAN_SUB_TYPES.PRO) {
                    handleProMultipleRatePlan(subscriptions, item);
                }

                if (!isBizPlusContext && isBizEditContext && key === ZOOM_MEETING_SUB_TYPES.BIZ) {
                    const bundlePlan = subscriptions.filter(p => getPlanTypeByCategory(p.category) === planTypes.ZOOM_UNITED || getPlanTypeByCategory(p.category) === planTypes.ZOOM_ONE_BUNDLE);
                    const hasBundlePlan = !!bundlePlan.length;
                    const bundleLicense = bundlePlan.map(p => p.quantity).reduce((acc, c) => acc + c, 0);
                    // check biz plan
                    const quantity = getMeetingPlanByCategory(subscriptions)?.quantity ?? ZOOM_MEETING_PRO_MIN_LICENSE;
                    // if no bundle plan, min host is 10
                    if (!hasBundlePlan) {
                        extraFields.min = quantity > ZOOM_MEETING_PRO_MIN_LICENSE ? ZOOM_MEETING_PRO_MIN_LICENSE : quantity;
                    } else {
                        // if has bundle plan, min host = 10 - bundleLicense
                        extraFields.min = Math.max(ZOOM_MEETING_PRO_MIN_LICENSE - bundleLicense, 1);
                    }
                }

                // PRO INCREASE - Pro Yearly & Monthly Plan Codes
                const priceChangeMappingPlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(item?.plan_code);

                return {
                    ...item,
                    ...extraFields,
                    typeNameKey: 'billing.planform.title.zoom_meeting_zoomonenew',
                    parentPlanNameKey: 'Zoom One',
                    priceChangeMappingPlanCode,
                    unit: window.$context?.is?.modalDelta ? planUnitMap.license : planUnitMap.user,
                    isEdu: [ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP].includes(item.category)
                }
            }),
        ]
    }, []);
    return meetingPlans;
}
